import { RootState } from 'editor/src/store/index';

const getAddonsElements = (state: RootState) => state.editorModules.addons.data?.results.elements;

export default getAddonsElements;
